export const capitalizeFirstLetter = function (val?: string) {
  return val ? val.charAt(0).toUpperCase() + val.slice(1) : "";
};
